import React from 'react';
import { Link } from 'react-router-dom';
import { useContracts } from '../hooks/useContracts';
import { COMPANY_INFO } from '../config/companyInfo';

function Footer() {
  const { contracts } = useContracts('all');

  // Contract mappings to routes
  const contractRoutes = {
    'privacy_policy': '/privacy',
    'terms_of_use': '/terms',
    'kvkk_consent': '/data-policy'
  };

  return (
    <footer className="bg-danger text-white text-center py-3 mt-5">
      <div className="container">
        {/* Tanıtıcı bilgiler (ETHS Yönetmeliği m.5) — her sayfada, "İletişim" niteliğinde.
            KEP adresi normal e-posta istemcisiyle açılamaz; bu yüzden bağlantı değil düz metin.
            MERSİS No 12.10.2026'da KULLANICI KARARIYLA footer'dan kaldırıldı (İSGA sitesiyle aynı gün);
            İletişim sayfasında ve sözleşme metinlerinde duruyor, COMPANY_INFO.mersis alanı kalır. */}
        <address className="small mb-3" style={{ fontStyle: 'normal', lineHeight: 1.6 }}>
          <div><strong>{COMPANY_INFO.legalName}</strong></div>
          <div>KEP: {COMPANY_INFO.kep}</div>
          <div>{COMPANY_INFO.address}</div>
          <div>
            <a href={`mailto:${COMPANY_INFO.email}`} className="text-white">{COMPANY_INFO.email}</a>
            {' · '}
            <a href={COMPANY_INFO.phoneHref} className="text-white">{COMPANY_INFO.phone}</a>
          </div>
          {COMPANY_INFO.etbisRegistered && (
            <div>
              E-ticaret hizmet sağlayıcısı olarak ETBİS'e kayıtlıdır ·{' '}
              <a href={COMPANY_INFO.etbisQueryUrl} target="_blank" rel="noreferrer" className="text-white">
                Kaydı görüntüle
              </a>
            </div>
          )}
        </address>
        <p className="mb-1">&copy; {new Date().getFullYear()} Katip Otomasyonu. Tüm hakları saklıdır.</p>
        <div className="d-flex flex-wrap justify-content-center gap-3">
          {/* Dynamic contract links */}
          {contracts && Object.entries(contractRoutes).map(([contractId, route]) => {
            const contract = contracts[contractId];
            return contract ? (
              <Link 
                key={contractId} 
                to={route} 
                className="text-white small text-decoration-underline"
              >
                {contract.title}
              </Link>
            ) : null;
          })}
          
          {/* Static copyright link — rota `/copyright` KALIR (eski bağlantılar
              kırılmasın), etiket sayfanın İKİ belgesini birden söyler: telif
              kaydı ve marka tescili. */}
          <Link to="/copyright" className="text-white small text-decoration-underline">Telif Hakkı ve Marka Tescili</Link>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
